<app-activatiegetal-lesgroepdashboard
  [geactiveerd]="data.geactiveerd" [totaal]="data.totaal">
</app-activatiegetal-lesgroepdashboard>
